import type React from 'react';

/**
 * Stop the mouse wheel from editing a focused `<input type="number">`.
 *
 * The browser default is that a focused number input treats the wheel as a
 * stepper, so a dispatcher scrolling down a field ticket can silently move
 * Qty 1 → 1.01 and change the invoice total with it. Confirmed on a live Dutch
 * Casing ticket.
 *
 * Blurring inside the wheel event drops the increment — an unfocused number
 * input ignores the wheel — while leaving the page free to keep scrolling.
 * `preventDefault()` would also stop the increment, but it freezes the page
 * whenever the cursor happens to sit over a line-item box, which is exactly
 * where it sits when this bug fires. Typing, tab, arrow keys and the stepper
 * arrows are untouched.
 *
 *     <input type="number" onWheel={blurOnWheel} ... />
 */
export function blurOnWheel(e: React.WheelEvent<HTMLInputElement>) {
  e.currentTarget.blur();
}
